import React from "react";
import Text from "../../../../../shared/components/Text";

export const NonControlledField = ({
  name,
  as: Component,
  placeholder,
  label,
  hidden,
  declaredField = false,
  ...rest
}) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {React.cloneElement(Component, {
        name,
        label: <Text tId={label} />,
        ...{ placeholder },
        style: {
          display: hidden ? "none" : "block",
          ...rest.style,
        },
        ...rest,
      })}
    </div>
  );
};
